module.exports = __webpack_public_path__ + "static/media/Curiosidades-Premio-Ebit-v.610dce56.610dce56.png";